<div class="form-group row">
  <div class="col-12">
    <form
      [formGroup]="auctionForm"
      novalidate
      class="needs-validation"
      (ngSubmit)="onSubmit()"
    >
      <div class="panel-content">
        <!-- Navegação por Abas (Steps) -->
        <ul class="nav nav-pills mb-3 justify-content-center" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="currentStep === 1"
              (click)="goToStep(1)"
              >1. Detalhes Básicos</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="currentStep === 2"
              (click)="goToStep(2)"
              >2. Agendamento & Lances</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="currentStep === 3"
              (click)="goToStep(3)"
              >3. Configurações</a
            >
          </li>
        </ul>

        <div class="tab-content">
          <div
            class="tab-pane fade"
            [class.show]="currentStep === 1"
            [class.active]="currentStep === 1"
          >
            <div class="form-row">
              <!-- Campo: Título -->
              <div class="col-12 mb-3">
                <div class="form-group">
                  <label class="form-label" for="title"
                    >Título do Leilão <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    id="title"
                    formControlName="title"
                    class="form-control"
                    placeholder="Ex: Leilão de Inglês Intensivo A1"
                    [ngClass]="{ 'is-invalid': submitted && f.title.errors }"
                  />
                  <div
                    *ngIf="submitted && f.title.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f.title.errors.required">
                      O título é obrigatório.
                    </div>
                    <div *ngIf="f.title.errors.maxlength">
                      Máximo de 100 caracteres.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Campo: Descrição -->
              <div class="col-12 mb-3">
                <div class="form-group">
                  <label class="form-label" for="description"
                    >Descrição <span class="text-danger">*</span></label
                  >
                  <textarea
                    id="description"
                    formControlName="description"
                    class="form-control"
                    rows="3"
                    placeholder="Descreva brevemente o leilão..."
                    [ngClass]="{
                      'is-invalid': submitted && f.description.errors
                    }"
                  ></textarea>
                  <div
                    *ngIf="submitted && f.description.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f.description.errors.required">
                      A descrição é obrigatória.
                    </div>
                    <div *ngIf="f.description.errors.maxlength">
                      Máximo de 500 caracteres.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Campo: Objetivo (Enum ExperimentalTarget) -->
              <div class="col-12 mb-3">
                <div class="form-group">
                  <label for="target"
                    >Objetivo do Curso <span class="text-danger">*</span></label
                  >
                  <select
                    id="target"
                    class="form-control"
                    formControlName="target"
                    [ngClass]="{
                      'is-invalid': submitted && f.target.errors
                    }"
                  >
                    <option [ngValue]="0" disabled>
                      Selecione um objetivo
                    </option>
                    <option
                      *ngFor="let target of experimentalTargets"
                      [ngValue]="target.value"
                    >
                      {{ target.text }}
                    </option>
                  </select>
                  <div
                    *ngIf="submitted && f.target.errors"
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="f.target.errors.required || f.target.errors.min"
                    >
                      Por favor, selecione um objetivo.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            [class.show]="currentStep === 2"
            [class.active]="currentStep === 2"
          >
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <div class="form-group">
                  <label class="form-label" for="startDate"
                    >Data de Início <span class="text-danger">*</span></label
                  >
                  <input
                    type="date"
                    id="startDate"
                    formControlName="startDate"
                    class="form-control"
                    [min]="minAuctionStartDate"
                    [ngClass]="{
                      'is-invalid':
                        (submitted && f.startDate.errors) ||
                        auctionForm.errors?.dateRangeInvalid
                    }"
                  />
                  <div
                    *ngIf="submitted && f.startDate.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f.startDate.errors.required">
                      A data de início é obrigatória.
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-group">
                  <label class="form-label" for="finishDate"
                    >Data de Encerramento
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="date"
                    id="finishDate"
                    formControlName="finishDate"
                    class="form-control"
                    [min]="f.startDate.value || minAuctionStartDate"
                    [ngClass]="{
                      'is-invalid':
                        (submitted && f.finishDate.errors) ||
                        auctionForm.errors?.dateRangeInvalid
                    }"
                  />
                  <div
                    *ngIf="submitted && f.finishDate.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f.finishDate.errors.required">
                      A data de encerramento é obrigatória.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Erro de range de datas (fora do campo específico) -->
              <div
                class="col-12"
                *ngIf="submitted && auctionForm.errors?.dateRangeInvalid"
                class="invalid-feedback d-block"
              >
                A data de encerramento deve ser posterior à data de início.
              </div>

              <!-- Campo: Número Máximo de Lances por Professor -->
              <div class="col-12 mb-3 mt-3">
                <div class="form-group">
                  <label class="form-label" for="maxNumberBids"
                    >Max. Lances por Professor
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    id="maxNumberBids"
                    formControlName="maxNumberBids"
                    class="form-control"
                    min="1"
                    max="99"
                    placeholder="Ex: 5"
                    [ngClass]="{
                      'is-invalid': submitted && f.maxNumberBids.errors
                    }"
                  />
                  <div
                    *ngIf="submitted && f.maxNumberBids.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="f.maxNumberBids.errors.required">
                      O número máximo de lances é obrigatório.
                    </div>
                    <div
                      *ngIf="
                        f.maxNumberBids.errors.min || f.maxNumberBids.errors.max
                      "
                    >
                      O valor deve ser entre 1 e 99.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            [class.show]="currentStep === 3"
            [class.active]="currentStep === 3"
          >
            <div class="form-row">
              <!-- Checkbox: Verificar Disponibilidade do Professor -->
              <div class="col-12 mb-3">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="checkTeacherAvailability"
                    formControlName="checkTeacherAvailability"
                  />
                  <label
                    class="custom-control-label"
                    for="checkTeacherAvailability"
                    >Verificar Disponibilidade do Professor</label
                  >
                </div>
              </div>

              <!-- Checkbox: Notificação WhatsApp -->
              <div class="col-12 mb-3">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="whatsAppNotification"
                    formControlName="whatsAppNotification"
                  />
                  <label class="custom-control-label" for="whatsAppNotification"
                    >Enviar Notificação por WhatsApp</label
                  >
                </div>
              </div>

              <!-- Checkbox: Notificação Email -->
              <div class="col-12 mb-3">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="emailNotification"
                    formControlName="emailNotification"
                  />
                  <label class="custom-control-label" for="emailNotification"
                    >Enviar Notificação por Email</label
                  >
                </div>
              </div>
            </div>

            <hr />

            <!-- Painel com Dicas para Preenchimento -->
            <div class="panel">
              <div class="panel-hdr">
                <h4 class="text-primary fw-700">
                  Dicas para Configuração do Leilão
                </h4>
              </div>
              <div class="panel-container show">
                <div class="panel-content">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      <i class="fal fa-info-circle mr-2 text-info"></i> Encerre
                      o leilão pelo menos 24h antes do início da aula.
                    </li>
                    <li class="list-group-item">
                      <i class="fal fa-calendar-alt mr-2 text-info"></i>
                      Considere um prazo de 3-7 dias para permitir participação
                      adequada.
                    </li>
                    <li class="list-group-item">
                      <i class="fal fa-users mr-2 text-info"></i> Leilões mais
                      longos tendem a ter mais participantes.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Seção de Mensagens de Erro Gerais -->
        <div
          class="alert alert-warning alert-dismissible text-left fade show mt-3"
          role="alert"
          *ngIf="!validAuctionForm && errorMessage"
        >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
          {{ errorMessage }}
        </div>

        <div
          *ngIf="
            listErrorMessage && listErrorMessage.length > 0 && !validAuctionForm
          "
          class="invalid-feedback d-block"
        >
          <div *ngFor="let error of listErrorMessage">{{ error }}</div>
        </div>

        <hr />

        <!-- Botões de Navegação e Ação -->
        <div class="row no-gutters">
          <div class="col-12 d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-default"
              (click)="goToStep(currentStep - 1)"
              [disabled]="currentStep === 1"
            >
              <i class="fal fa-arrow-left mr-1"></i> Anterior
            </button>
            <div>
              <button
                type="button"
                class="btn btn-primary mr-2"
                (click)="goToStep(currentStep + 1)"
                [disabled]="currentStep === totalSteps || submitted"
                *ngIf="currentStep < totalSteps"
              >
                Próximo <i class="fal fa-arrow-right ml-1"></i>
              </button>
              <button
                id="js-submit-btn"
                class="btn btn-success"
                [disabled]="submitted"
                type="submit"
                *ngIf="currentStep === totalSteps"
              >
                <span
                  *ngIf="submitted"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                Salvar Leilão
              </button>
              <button
                id="js-cancel-btn"
                class="btn btn-default ml-2"
                (click)="onCancel()"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
